import { Cancel } from "@mui/icons-material";
import { FormControl, IconButton, InputAdornment, InputLabel, OutlinedInput, SxProps, Theme } from "@mui/material";

import { GqlFilterOptionText } from "~/__generated__";

type Props = {
    sx: SxProps<Theme>;
    option: GqlFilterOptionText;
    size: "small" | "medium";
    value: string;
    onChange: (value: string) => void;
};

export default function TextFilter({ sx, option, size, value, onChange }: Props) {
    return (
        <FormControl variant="outlined" sx={sx} size={size}>
            <InputLabel htmlFor={`filter-field-${option.key}`}>{option.label}</InputLabel>
            <OutlinedInput
                id={`filter-field-${option.key}`}
                size={size}
                value={value}
                onChange={e => onChange(e.target.value)}
                label={option.label}
                endAdornment={
                    value && (
                        <InputAdornment position="end">
                            <IconButton size="small" onClick={() => onChange("")} edge="end">
                                <Cancel />
                            </IconButton>
                        </InputAdornment>
                    )
                }
            />
        </FormControl>
    );
}
